// extracted by mini-css-extract-plugin
export default {"wrapper":"PaddingContainer_wrapper__7E0Qu"};